import * as React from 'react';

import {File} from '../files/file';

import type {Attachment} from './types';

import styles from './attachment-list.module.css';

type Props = {
    attachments: Attachment[];
};

export function AttachmentList(props: Props) {
    return (
        <div className='attachments-container'>
            {props.attachments.map((file) => (
                <div key={file.fileId} className={styles.file}>
                    <File
                        id={file.fileId}
                        filename={file.name}
                        filetype={file.fileType}
                        href={file.href}
                        withDownloadIcon={false}
                        withNoBorder={true}
                    />
                </div>
            ))}
        </div>
    );
}
